// extracted by mini-css-extract-plugin
export default {"titular":"CredencialComponent_titular__mcjCx","td":"CredencialComponent_td__9DA3j"};